jQuery(function ($) {
    $("#accordion").accordion({
      heightStyle: "content",
    });
  });
  
  // Device Accordion - Memories
  jQuery(function ($) {
    var value_gb;
    $("#device-information .memory-block p").each(function () {
      $(this).on("click", function () {
        if (!$(this).hasClass("memory-active")) {
          $(this).addClass("memory-active");
          $(this).removeClass("drop-shadow");
          $(this).siblings().removeClass("memory-active");
          $(this).siblings().addClass("drop-shadow");
  
          //   Change Memory on click to the selected memories
          value_gb = $(this).text();
          $("#selected-memory-value").text(value_gb);
          $(".device-size").text(value_gb);
        }
      });
    });
  
    //   Modal Open/Close
    $("#device-information .description-modal").on("click", function () {
      if (!$("#device-information .modal-container").hasClass("active")) {
        $("#device-information .modal-container").toggleClass("active");
        $(".overlay-device").toggleClass("overlay-active");
        $("body").css("overflow-y", "hidden");
      }
    });
  
    // Close button
    $(".modal-container .modal-data i").on("click", function () {
      $("#device-information .modal-container").removeClass("active");
      $(".overlay-device").removeClass("overlay-active");
      $("body").css("overflow-y", "unset");
    });
  
    // Close model when Clicked on overlay
    $(".overlay-device").on("click", function () {
      $("#device-information .modal-container").removeClass("active");
      $(".overlay-device").removeClass("overlay-active");
      $("body").css("overflow-y", "unset");
    });
  
    //   Continue Button
    //   $(".open-next-accordion").on("click", function () {
    //     $(".accordion-item").each(function(){
    //         $(".accordion-item")
    //     })
    //   });
  
    //   Select Color and Change Image Accordingly
    var color_id;
    var color_name;
    $(".outline-green").each(function () {
      $(this).on("click", function () {
        color_id = $(this).attr("data-colorid");
        color_name = $(this).attr("data-colorname");
        
        $(this).addClass("active-outline");
        $(this).siblings().removeClass("active-outline");
  
        $(".mobile-image-color").each(function () {
          $(".mobile-image-color").addClass("d-none");
          $("#" + color_id).removeClass("d-none");
        });
  
        // Dynamic Color Name Text Change
        
        $(".change-color").text(color_name);
        $(".device-color").text(color_name);
      });
    });
  });
  
  // ------------------- Payment Accordion JS ---------------------------
  // let EMIFinal = "";
  // let entertedDownPay = "";
  let entertedDownPay = "";
  let EMIFinal = "";
  
  jQuery(function ($) {
    // Get the Mobile's outright price - On Page Load
    var mobile_price = $(".payment-blocks .get-price-block").text();
    var outright = parseFloat(mobile_price);
    // console.log(typeof outright);
    var downpayment = $("#emi-sub-block .form-control").val();
  
    // Logic to allow user to enter value upto mobile price
  
    var emi = (outright - downpayment) / 24;
  
    let wholeAmountOnEmi = $(".put-price-back-block").text("$" + emi.toFixed(2));
    // console.log(wholeAmountOnEmi);
  
    // Reflect EMI amount on key up
    $("#emi-sub-block .form-control").on("keyup", function (e) {
      entertedDownPay = $("#emi-sub-block .form-control").val();
      let emi = (outright - entertedDownPay) / 24;
  
      if (entertedDownPay <= outright) {
        EMIFinal = $(".put-price-back-block").text("$" + emi.toFixed(2));
      } else {
        // $(".paid-down-payment").addClass("d-none");
        return false;
      }
  
      if ($("#emi-checked:checked").val()) {
        if (!$(".pay-full-amout-header-text").hasClass("d-none")) {
          $(".pay-full-amout-header-text").addClass("d-none");
        }
  
        $(".payment-term-header-info").removeClass("d-none");
        $(".selected-payment-option").text("Finance over 24 months");
  
        if (entertedDownPay) {
          $(".paid-down-payment").text("$" + entertedDownPay + " down today");
        } else {
          $(".paid-down-payment").text("$" + 0 + " down today");
        }
  
        $(".monthly-payment").text(
          EMIFinal[0].innerHTML + " per month on your TCC TAB"
        );
  
        // console.log("Hello World");
      }
    });
  
    // Get the Value of EMI to use later
    let price_EMI = $(".put-price-back-block").text();
  
    $("#amount-checked").on("click", function () {
      $(".tab-credit").addClass("d-none");
      $(".payment-term-header-info").addClass("d-none");
      $(".form-control").val(" ").prop("disabled", true);
      $(".pay-full-amout-header-text").removeClass("d-none");
      $(".put-price-back-block").text("$" + (outright / 24).toFixed(2));
  
      // Summary hide monthly tags
      // $("#summary-accordion .tax-summary").addClass("d-none");
      $(".tax-summary-month").addClass("d-none");
      $(".total-summary-month").addClass("d-none");
    });
  
    $("#emi-checked:checked").on("click", function () {
      $(".tab-credit").removeClass("d-none");
      if (!$(".pay-full-amout-header-text").hasClass("d-none")) {
        $(".pay-full-amout-header-text").addClass("d-none");
      }
      $(".form-control").prop("disabled", false);
  
      // Summary show monthly tags
      $("#summary-accordion .tax-summary").removeClass("d-none");
      $(".tax-summary-month").removeClass("d-none");
      $(".total-summary-month").removeClass("d-none");
    });
  
    console.log($("#emi-sub-block .form-control").val());
    // Radio Button
  });
  
  // ------------------- Payment Accordion JS ends ---------------------------
  
  // ------------------- Choose Plan -------------------------------
  let selectedPlanString = "";
  
  jQuery(function ($) {
    $("#mobile--accordion  .tab-content .tab-pane .sub-promotion-block").each(
      function () {
        // On Click
        $(this).on("click", function () {
          $("#mobile--accordion  .tab-content .tab-pane").each(function () {
            $("#mobile--accordion  .tab-content .tab-pane")
              .find(".sub-promotion-block")
              .not(this)
              .removeClass("active");
          });
  
          if (!$(this).hasClass("active")) {
            $(this).addClass("active");
          }
  
          // get the price
          let plan_price = $(this).find(".price-block").children()[0].innerHTML;
          // let removeDollarsign = plan_price.replace("$", "");
  
          // get the decimal value
          let plan_decimal =
            $(this).find(".decimal-block ")[0].childNodes[1].innerHTML;
  
          selectedPlanString = plan_price + "." + plan_decimal;
  
          // Grab the services of plan
          let services = $(this).find(".promo-service-list-block")[0].children[0]
            .innerText;
  
          // console.log($(this).find(".promo-service-list-block")[0].children);
  
          var str = nl2br(services);
          // Putting back price in accordion header
  
          $(".choose-plan-header-text").removeClass("d-none");
          $(".choose-plan-header-text").text(selectedPlanString + " Unlimited");
  
          // Services
          $(".service-block-header").removeClass("d-none");
          $(".service-block-header").html(str);
        });
      }
    );
  });
  
  function nl2br(services, is_xhtml) {
    var breakTag = is_xhtml || typeof is_xhtml === "undefined" ? "<br />" : "";
    return (services + "").replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, breakTag);
  }
  
  // ------------------- Choose Plan Ends-------------------------------
  
  // -------------------- Summary Section ------------------------------
  jQuery(function ($) {
    var mobile_price = $(".payment-blocks .get-price-block").text();
    var outright = parseFloat(mobile_price);
  
    $(".tax-summary:first-child").addClass("d-none");
    // with EMI
    $("#emi-sub-block .form-control").on("keyup", function () {
      $(".tax-summary:first-child").removeClass("d-none");
  
      var downpayment = parseFloat($("#emi-sub-block .form-control").val());
      // Add tax to downpayment
      var downWithTax = (downpayment * 0.13).toFixed(2);
  
      // Get the install ment price
      var emi = $(".put-price-back-block").text().replace("$", "");
  
      // Add Tax to installment
      var emiWithTax = (parseFloat(emi) * 0.13).toFixed(2);
  
      $(".tax-summary-tax").text("$" + downWithTax + " " + "now");
      // console.log("lol=", $(".tax-summary-tax").text("$" + downpayment * 0.13));
      $(".tax-summary-month").text("$" + emiWithTax + " " + "per month");
  
      // Total - Emi installment with tax
      $(".total-summary-month").text(
        "$" +
          (parseFloat(emiWithTax) + parseFloat(emi)).toFixed(2) +
          " " +
          "per month"
      );
  
      // Total - down with tax
      $(".total-summary-tax").text(
        "$" +
          (parseFloat(downpayment) + parseFloat(downWithTax)).toFixed(2) +
          " " +
          "now"
      );
    });
  
    // Value if they paying out full amount
    $("#amount-checked").on("click", function () {
      var outrightWithTax = outright * 0.13 + outright;
      $(".tax-summary-tax").text("$" + outright * 0.13);
      $(".total-summary-tax").text("$" + outrightWithTax);
    });
  
    // Print Button
    $("#print-summary").on("click", function () {
      window.print();
    });
  });
  
  // -------------------- Summary Section ------------------------------
  
  // Continue Button
  
  jQuery(function ($) {
    // Device info first accordion
  
    $("#open-next-accordion").on("click", function () {
      console.log("clicked");
      // Close same accordion body and show its Header
      $(this).parents()[5].classList.remove("show");
      $(this).parents()[6].childNodes[1].childNodes[1].ariaExpanded = "false";
  
      // Open Next Element
      // console.log($(this).parents()[6]);
      // console.log($(this).parents()[6].nextElementSibling);
  
      if ($(this).parents()) {
        console.log("clicked next");
        $(
          this
        ).parents()[6].nextElementSibling.childNodes[3].childNodes[1].ariaExpanded =
          "true";
        // $(this).parents()[7].nextElementSibling.classList.add("show");
        console.log(
          $(this)
            .parents()[6]
            .nextElementSibling.childNodes[7].classList.add("show")
        );
      }
    });
  
    // Rest of the accordion continue button
    $(".rest-two-accordion").each(function () {
      $(this).on("click", function () {
        // Close open Tab first
        $(this).parent().parent().removeClass("show");
        $(this).parent().parent().prev().children()[0].ariaExpanded = "false";
        // Open Next Accordion
        var accordion_item = $(this).parent().parent().parent();
  
        accordion_item.next().children()[0].childNodes[1].ariaExpanded = "true";
        console.log(accordion_item.next().children()[1].classList.add("show"));
      });
    });
  
    // Choose Plan continue btn -> scroll to top on click
    // $("#last-choose-plan-button").on("click", function () {
    //   $(window).scrollTop(500);
    //   console.log("Hello Button");
    // });
  
    // Lets get started Overlay
    $("#started-button").on("click", function () {
      console.log("lets");
      if (!$("#lets-get-started").hasClass("active")) {
        $("#lets-get-started").addClass("active");
        $(".overlay-device").toggleClass("overlay-active");
        $("body").css("overflow-y", "hidden");
      }
    });
  
    // Close button
    $("#lets-get-started .close-started-overlay i").on("click", function () {
      $("#lets-get-started").removeClass("active");
      $(".overlay-device").removeClass("overlay-active");
      $("body").css("overflow-y", "unset");
    });
  
    // Close model when Clicked on overlay
    $(".overlay-device").on("click", function () {
      $("#lets-get-started").removeClass("active");
      $(".overlay-device").removeClass("overlay-active");
      $("body").css("overflow-y", "unset");
    });
  
    // Social Hub - add drop shadow class
    $(".juicer-feed")
      .find(".feed-item")
      .each(function () {
        $(this).addClass("drop-shadow");
      });
  });
  